import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';

let userPool = null;

export function initializeCognito(userPoolId, clientId) {
  userPool = new CognitoUserPool({
    UserPoolId: userPoolId,
    ClientId: clientId
  });
}

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    if (!userPool) {
      reject(new Error('Cognito not initialized'));
      return;
    }

    const authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password
    });

    const cognitoUser = new CognitoUser({
      Username: email,
      Pool: userPool
    });

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: (result) => {
        resolve({
          idToken: result.getIdToken().getJwtToken(),
          accessToken: result.getAccessToken().getJwtToken()
        });
      },
      onFailure: (err) => {
        reject(err);
      }
    });
  });
}

export function getCurrentUser() {
  if (!userPool) return null;
  return userPool.getCurrentUser();
}

export function getIdToken() {
  return new Promise((resolve, reject) => {
    const currentUser = getCurrentUser();
    if (!currentUser) {
      reject(new Error('No user logged in'));
      return;
    }

    currentUser.getSession((err, session) => {
      if (err) {
        reject(err);
        return;
      }
      if (!session.isValid()) {
        reject(new Error('Session is invalid'));
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

export function signOut() {
  const currentUser = getCurrentUser();
  if (currentUser) {
    currentUser.signOut();
  }
}
